import React from 'react';
import { ClassAssembly10B2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly10B2026 />;
  };
  
  export default ClassAssemblyPage;